class ImageTextRow extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.enableSlider !== 'true') {
      return
    }

    this.init();
  }

  init() {
    const desktopColumns = Number(this.dataset.desktopColumns) || 4;

    this.carousel = new Splide(this.querySelector('.splide'), {
      arrows: false,
      gap: 'var(--spacing-md)',
      perPage: desktopColumns,
      breakpoints: {
        768: {
          perPage: 1,
        }
      }
    });

    this.carousel.mount();
  }
}

customElements.define('image-text-row', ImageTextRow);
